module.exports = __webpack_public_path__ + "static/media/puerta_ocre.c1f74a62.jpg";